module.exports = __webpack_public_path__ + "fonts/Acumin-BdPro.f55e6e6.otf";